"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keywordSearchOptions = void 0;
var isStringMatch_1 = require("../../../utils/isStringMatch");
var keywordSearchOptions = function (_a) {
    var options = _a.options, searchString = _a.searchString, searchFieldsConfig = _a.searchFieldsConfig, setFilteredOptionsInParent = _a.setFilteredOptionsInParent;
    if (options.some(function (d) { return d.loading === true; }))
        return options; //if any of the options are still loading, then dont even try to do this filter thing
    //else
    var toReturn = options.filter(function (d) {
        return (0, isStringMatch_1.isStringMatch)({ data: d, toMatchPath: searchFieldsConfig || 'display', subString: searchString });
    });
    //we want to track filtered options only if a search is being conducted
    //this will help us to select the most relevant option if user hits 'enter' instead of clicking on option.
    setFilteredOptionsInParent && searchString && setFilteredOptionsInParent(toReturn);
    return toReturn;
};
exports.keywordSearchOptions = keywordSearchOptions;
